module.exports = __webpack_public_path__ + "images/search_bg2.gif";